import React, { Component } from "react";
import { connect } from "react-redux";
import PlaceHolder from '../../../../FO/resources/img/placeholder-image.png';
import CinemapSlider from '../../../../SHARED/components/slider/slider.component';

class MovieTheater extends Component {

    getContent = () => {
        if (this.props.images.length !== 0){
            return <CinemapSlider slides={ this.props.images} />
        }
        else {
            return <img className="placeholder" src={PlaceHolder} alt={"Cinema"} />
        }
    }

    render() {
        return (
            <div>
                {this.getContent()}
            </div>
        );
    }
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, {})(MovieTheater);


// WEBPACK FOOTER //
// ./src/FO/components/movietheaters/containers/movietheater.component.js